import React from "react";
import { DownOutlined, LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Menu, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import "react-day-picker/lib/style.css";
import ".././App.css";
import {
  Avatar,
  DatePicker,
  Dropdown,
  Radio,
  Space,
  Tooltip,
} from "antd";
import { format, addDays, parse } from "date-fns";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ApiWrapper from ".././utils/ApiWrapper.js";
import { abortController } from "../utils/ApiWrapper";
import CustomSearchHeader from "./CustomSearchHeader.js";
import PageHeader from "./PageHeader.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DateRangePicker } from "react-date-range";
import { ChannelContext } from "../context/ChannelContext";
import Paper from "@material-ui/core/Paper";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import DoneRoundedIcon from "@material-ui/icons/DoneRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import SwapHorizRoundedIcon from "@material-ui/icons/SwapHorizRounded";
import DateRangeRoundedIcon from "@material-ui/icons/DateRangeRounded";
import NoteAddRoundedIcon from "@material-ui/icons/NoteAddRounded";
import logo from ".././images/Forcesight_Logo.svg";
import { useEffect } from "react";

const { RangePicker } = DatePicker;

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 44,
  },
  title: {
    flexGrow: 1,
  },
  marketplace: {
    fontSize: 14,
    fontWeight: 500,
  },
  calendarButton: {
    minWidth: 160,
  },
  checkbox: {
    width: 16,
    height: 16,
    backgroundColor: "#2684FF",
  },
  syncButton: {
    marginStart: 26,
  },
  accountSelector: {
    marginTop: 44,
  },
});

const ManualSyncButton = withStyles({
  root: {
    fontSize: 14,
    fontWeight: 500,
  },
  contained: {
    background: "#2684FF",
    color: "#FFFFFF",
    "&:hover": {
      background: "#0065FF",
      color: "#FFFFFF",
    },
  },
  label: {
    textTransform: "capitalize",
  },
})(Button);

const CustomCheckBox = withStyles({
  root: {
    paddingLeft: 9,
    paddingRight: 9,
    paddingTop: 9,
    paddingBottom: 9,
    color: "#2684FF",
    "&:checked": {
      color: "#2684FF",
    },
  },
})(Checkbox);

const CustomMenuItem = withStyles({
  root: {
    fontSize: 14,
    fontWeight: 500,
  },
  gutters: {
    paddingLeft: 0,
  },
})(MenuItem);

const quickDateFilters = [
  { name: "Today", id: "today" },
  { name: "Yesterday", id: "yesterday" },
  { name: "Last Week", id: "last-week" },
  { name: "Last Month", id: "last-month" },
];

function getUpdatedMarketplaceText(selectedMarketplaces) {
  var text;
  var selectedNumber = 0;
  for (var i = 0; i < selectedMarketplaces?.length; i++) {
    if (selectedMarketplaces[i].checked === true) {
      selectedNumber++;
      text = selectedMarketplaces[i].name;
    }
  }

  if (selectedNumber >= 1) {
    text = `${selectedNumber}`;
  }
  if (selectedNumber === 0) {
    text = "0";
  }
  return text;
}

let SyncInterval;
function CustomFilterHeader(props) {
  const data = JSON?.parse(localStorage.getItem("cmpy_info")) || {};

  const location = useLocation();
  const history = useNavigate();
  const classes = useStyles();
  const [isSelectionBool, setIsSelectionBool] = React.useState(false);
  const [selectAll, setSelectAll] = React.useState(true);
  const [indeterminate, setIndeterminate] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showManualSync, setShowManualSync] = React.useState(false);
  const [dateRange, setDateRange] = React.useState();
  const [datePickerOpen, setDatePickerOpen] = React.useState(false);
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [selectedToDate, setSelectedToDate] = React.useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState([
    {
      startDate: new Date(props.filter.startDate),
      endDate: new Date(props.filter.endDate),
      key: "selection",
    },
  ]);

  // const { currentChannel, setCurrentChannel } = React.useContext(ChannelContext);
  React.useEffect(() => {
    if (props.filter.dateFilter) {
      switch (props.filter.dateFilter) {
        case "today":
          updateDateAndSendCallback(
            moment().startOf("days").subtract(1, "milliseconds").utc().format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "yesterday":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "day")
              .utc()
              .format(),
            moment().endOf("days").subtract(1, "day").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "last-week":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "week")
              .utc()
              .format(),
            moment().endOf("day").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "last-month":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "month")
              .utc()
              .format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
        default:
          updateDateAndSendCallback(
            moment().startOf("days").subtract(1, "milliseconds").utc().format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
      }
    } else if (props.filter.startDate && props.filter.endDate) {
      updateDateAndSendCallback(
        moment(props.filter.startDate).startOf("day").utc().format(),
        moment(props.filter.endDate).endOf("day").utc().format(),
        props.filter.reviewStatus
      );
    }
    CheckPendingSync();
  }, []);
  const SetManualPendingSyncTimeout = () => {
    SyncInterval = setInterval(() => {
      CheckPendingSync();
    }, 3000000); //3 sec, 3000000
  };
  const CheckPendingSync = () => {
    if (props.manualSyncModule) {
      let requestJsonBody = {
        module: props.manualSyncModule,
      };
      ApiWrapper("manualPendingSync", requestJsonBody).then(
        function (response) {
          setLoading(false);
          if (response.status) {
            if (!response.requests.length) {
              clearInterval(SyncInterval);
              SyncInterval = 0;
              setShowManualSync(true);
            } else {
              SetManualPendingSyncTimeout();
              setShowManualSync(false);
            }
            //props.reloadApi(data);
          }
        },
        function (error) {
          setLoading(false);
          // message.error(
          //   "We encountered an issue. Please log out and log back in. "
          // );
        }
      );
    }
  };
  const handleMarketplaceMenuButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMarketplaceMenuClose = (event, value) => {
    setAnchorEl(null);
  };

  const handleMarketplaceCheck = (event, row) => {
    // let newArr =  currentChannel && currentChannel;
    let newArr = [...props.filter.marketplace];
    for (let i = 0; i < newArr.length; i++) {
      if (newArr[i].id === row.id) {
        // newArr[i].checked = event.target.checked;
        if (event.target.checked) {
          newArr[i].checked = true;
        } else {
          newArr[i].checked = false;
        }
      }
    }
    const checkedCount = newArr.filter((item) => item.checked).length;
    const indeterminate = checkedCount > 0 && checkedCount < newArr.length;
    setIndeterminate(indeterminate);
    if(checkedCount === 0){
      setSelectAll(false)
    }
    if(checkedCount === newArr.length){
      setSelectAll(true)
    }
    
    // setCurrentChannel(newArr);
    abortController &&
      Object.keys(abortController).map((fetchCall) => {
        abortController[fetchCall].abort();
      });
    props.updateMarketplace({ marketplace: newArr });
  };
  const handleMarketplaceSelection = (val) => {
    setIsSelectionBool(!val);
    const updatedMarketplace = props.filter.marketplace.map((item) => ({
      ...item,
      checked: val,
    }));

    props.updateMarketplace({ marketplace: updatedMarketplace });
  };

  const toggleSelectAll = (e) => {
    const newSelectedItems = props.filter.marketplace.map((item) => ({
      ...item,
      checked: e.target.checked,
    }));
    setIndeterminate(false);
    setSelectAll(e.target.checked);
    props.updateMarketplace({ marketplace: newSelectedItems });
  };

  useEffect(() => {
    // let uniqueChannel = JSON.parse(localStorage.getItem("updateChannel"));
    // props.updateMarketplace({ marketplace: uniqueChannel });
    if (window.performance) {
      if (performance.navigation.type == 1) {
        let uniqueChannel = JSON.parse(localStorage.getItem("updateChannel"));
        props.updateMarketplace({ marketplace: uniqueChannel });
      }
    }
  }, []);

  function onChannelSubmit() {
    updateDateAndSendCallback(
      selectedFromDate,
      selectedToDate,
      props.filter.reviewStatus
    );
  }

  const onDateRangeSelect = (selectedDates) => {
    props.updateDateFilter({
      dateFilter: null,
      startDate: selectedDates[0],
      endDate: selectedDates[1],
    });

    if (selectedDates[0] && selectedDates[1]) {
      updateDateAndSendCallback(
        moment(selectedDates[0]).startOf("day").utc().format(),
        moment(selectedDates[1]).endOf("day").utc().format(),
        props.filter.reviewStatus
      );
    } else {
      handleQuickDateFilterType({}, "last-month");
    }
  };

  const onReviewTypeChanged = (newStatus) => {
    props.updateReviewFilter({ reviewStatus: newStatus });
    updateDateAndSendCallback(
      moment(selectedFromDate).startOf("day").utc().format(),
      moment(selectedToDate).startOf("day").utc().format(),
      newStatus
    );
  };

  const handleQuickDateFilterType = (event, newFilterValue) => {
    if (newFilterValue) {
      props.updateDateFilter({
        dateFilter: newFilterValue,
        startDate: null,
        endDate: null,
      });
      switch (newFilterValue) {
        case "today":
          updateDateAndSendCallback(
            moment().startOf("days").subtract(1, "milliseconds").utc().format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "yesterday":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "day")
              .utc()
              .format(),
            moment().endOf("days").subtract(1, "day").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "last-week":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "week")
              .utc()
              .format(),
            moment().endOf("day").utc().format(),
            props.filter.reviewStatus
          );
          break;
        case "last-month":
          updateDateAndSendCallback(
            moment()
              .startOf("days")
              .subtract(1, "milliseconds")
              .subtract(1, "month")
              .utc()
              .format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
        default:
          updateDateAndSendCallback(
            moment().startOf("days").subtract(1, "milliseconds").utc().format(),
            moment().endOf("days").utc().format(),
            props.filter.reviewStatus
          );
          break;
      }
    }
  };

  const updateDateAndSendCallback = (fromDate, toDate, reviewTypeStatus) => {
    setSelectedFromDate(fromDate);
    setSelectedToDate(toDate);

    var arrayToSend = [];
    // currentChannel && currentChannel.forEach((item, i) => {
    props.filter.marketplace.forEach((item, i) => {
      if (item.checked) {
        arrayToSend.push(item);
      }
    });
    props.handleMarketplaceChange(
      arrayToSend,
      fromDate,
      toDate,
      reviewTypeStatus
    );
  };

  const handleManualSync = () => {
    setLoading(true);
    if (props.manualSyncModule) {
      let requestJsonBody = {
        module: props.manualSyncModule,
      };
      setShowManualSync(false);
      SetManualPendingSyncTimeout();
      // return;
      ApiWrapper("manualSync", requestJsonBody).then(
        function (response) {
          setLoading(false);
          if (response.status) {
            setShowManualSync(false);
            SetManualPendingSyncTimeout();
            //props.reloadApi(data);
          }
        },
        function (error) {
          setLoading(false);
          // message.error(
          //   "We encountered an issue. Please log out and log back in. "
          // );
        }
      );
    }
  };
  function onChange(value, dateString) {
    setDatePickerOpen(true);
    setDateRange(dateString);
  }
  function onSubmit() {
    onDateRangeSelect([
      format(state[0].startDate, "yyyy-MM-dd"),
      format(state[0].endDate, "yyyy-MM-dd"),
    ]);
    setDatePickerOpen(false);
  }
  const handleSliderCollapse = () => {
    props.updateSliderFilter({
      sliderCollapsed: !props.filter.sliderCollapsed,
    });
  };
  const handleDashboardClick = (e) => {
    history("/profitability/0");
  };

  return (
    <div className="max-w-full mx-auto sticky top-0 z-50">
      <div
        className={`flex items-center tablet:justify-between ${
          props.isLoading ? "cursor-not-allowed" : ""
        }`}
      >
        <div
          className={`${
            props.isLoading ? "pointer-events-none cursor-not-allowed" : ""
          }`}
        >
          {/* <Grid container>
                {props.filter.marketplace.map((row, i) =>
                  row.checked ? (
                    <div
                      key={`Grid-${i}`}
                      className="flex items-center font-medium text-sm bg-white rounded ml-2"
                      style={{
                        padding: "2px 6px",
                        color: "#44444F",
                        border: "1px solid #DFE1E6",
                      }}
                    >
                      {row.name}
                      <div
                        onClick={(event) =>
                          handleMarketplaceCheck(event, row)
                        }
                        className={"ml-2 w-3 cursor-pointer"}
                      >
                        <img src={Close} width={12} alt="close" />
                      </div>
                    </div>
                  ) : null
                )}
              </Grid> */}
        </div>
      </div>
      {/* Common Section 🟢 */}
      <div className="flex justify-between items-center bg-white py-1 px-4 tablet:px-2 border-grey-500 custom-border-b customheader">
        {/* Left Section 🟢 */}
        <div className="logoHolder">
          <div
            className="flex-shrink-0 flex items-center"
            onClick={handleDashboardClick}
          >
            <Link to="/profitability/0">
              <img
                className="block lg:hidden h-8 w-auto cursor-pointer"
                src={logo}
                alt="Workflow"
              />
            </Link>
            <Link to="/profitability/0">
              <img
                className="hidden lg:block h-8 w-auto "
                src={logo}
                alt="Workflow"
              />
            </Link>
          </div>
          {/* <div onClick={handleSliderCollapse} className="cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
              />
            </svg>
          </div> */}
        </div>
        <div className="flex justify-between items-center ml-4 w-full">
          <PageHeader title={props.headerTitle} />
          {/* Right Section 🔴 */}
          <div className="flex items-center sm:flex-wrap lg:flex-nowrap sm:justify-end lg:justify-between header-btn">
            {/* <div className={`${props.isLoading ? "cursor-not-allowed" : ""}`}>
              <div
                className={`${props.isLoading ? " pointer-events-none" : ""}`}
              > */}
            {props.showSearchBar && (
              <CustomSearchHeader
                onSearchTextEntered={props.onSearchTextEntered}
                searchFunction={props.searchFunction}
                onProfitToggleChange={props.onProfitToggleChange}
                showReviewToggle={props.showReviewToggle}
                selectedReviewStatus={props.filter.reviewStatus}
                onReviewTypeChanged={onReviewTypeChanged}
                showExportButton={props.showExportButton}
                getExportData={props.getExportData}
                publishButton={props.publishButton}
                showAllReviews={props.showAllReviews}
                searchInput={props.searchInput}
                campaigns={props.campaigns}
                columns={props.columns}
                rows={props.rows}
                searchHide={props.searchHide}
                exportFileName={props.exportFileName}
                bulkUpload={props.bulkUpload}
                onFilterUpdate={props.onFilterUpdate}
                customToggleProfit={props.customToggleProfit}
                customExportButton={props.customExportButton}
                dateRange = {state}
              />
            )}
            {/* </div>
            </div> */}
            {/* From - To 🟢 */}
            {props.showDateRanges !== false && (
              <div className="nav flex justify-between gap-1.5 items-center">
                {/* <p className="text-base font-medium"
                  style={{ color: '#6B7280' }}
                >Order Date:</p> */}
                <div
                  className={`${
                    props.isLoading
                      ? "pointer-events-none cursor-not-allowed"
                      : ""
                  }`}
                >
                  <div className="nav">
                    <Dropdown
                      overlay={
                        <Paper
                          elevation={3}
                          className="border-2 border-solidrounded-lg shadow-inner"
                        >
                          <DateRangePicker
                            className="rounded-lg"
                            onChange={(item) => setState([item.selection])}
                            showSelectionPreview={true}
                            moveRangeOnFirstSelection={false}
                            months={2}
                            ranges={state}
                            preventSnapRefocus={true}
                            calendarFocus="backwards"
                            // minDate={addDays(new Date(state[0].endDate), -90)}
                            maxDate={
                              location?.pathname === "/reviews"
                                ? addDays(new Date(state[0].startDate), +9999)
                                : addDays(new Date(state[0].startDate), +93)
                            }
                            // staticRanges={[]}
                            inputRanges={[]}
                            direction="horizontal"
                            footerContent={
                              <Space direction="horizontal">
                                <div className="pl-1">
                                  <Button
                                    startIcon={<DoneRoundedIcon />}
                                    className="bg-primary text-white normal-case"
                                    variant="contained"
                                    size="medium"
                                    onClick={() => {
                                      onSubmit();
                                    }}
                                  >
                                    Submit
                                  </Button>
                                </div>
                                <div className="">
                                  <Button
                                    startIcon={<CloseRoundedIcon />}
                                    className="bg-primary text-white normal-case"
                                    variant="contained"
                                    size="medium"
                                    onClick={() => {
                                      setDatePickerOpen(false);
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </Space>
                            }
                          />
                        </Paper>
                      }
                      trigger={["click"]}
                      placement="bottomLeft"
                      arrow
                      visible={datePickerOpen}
                    >
                      <Button
                        size="small"
                        onClick={(e) => {
                          e.preventDefault();
                          setDatePickerOpen(true);
                        }}
                      >
                        <div
                          className="h-9 flex justify-center items-center shadow-none rounded-lg text-base font-medium px-2"
                          style={{
                            backgroundColor: "#FCFCFC",
                            padding: "2.5px",
                            border: "1px solid #D6DBE7",
                          }}
                        >
                          <>
                            {" "}
                            <p
                              className="pl-1"
                              style={{ color: "#6B7280", fontSize: "14px" }}
                            >
                              {format(
                                new Date(props.filter.startDate),
                                "dd-MM-yy"
                              )}
                              <SwapHorizRoundedIcon
                                style={{
                                  color: "#333",
                                  margin: "0 4px 0 4px",
                                  fontSize: "14px",
                                  marginTop: "4px",
                                }}
                              />
                              {format(
                                new Date(props.filter.endDate),
                                "dd-MM-yy"
                              )}
                            </p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="w-5 h-5 ml-2 text-slate-300"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                              />
                            </svg>
                          </>
                        </div>
                      </Button>
                    </Dropdown>
                  </div>
                </div>
                {props.customDateText && (
                  <p
                    className="text-xs mr-0"
                    style={{ width: "85px", lineHeight: "16px" }}
                  >
                    {props.customDateText}
                  </p>
                )}
              </div>
            )}
            {/* From - To 🔴 */}

            <>{props.customHeader}</>
            {/* Right Section 🟢 */}
            <div className="flex justify-between items-center gap-4">
              <>
                {/* Marketplace 🟢 */}
                {!props.channelHide && (
                  <div
                    className={`${props.isLoading ? "cursor-not-allowed" : ""}`}
                  >
                    <div
                      className={`flex justify-between items-center
                  ${
                    props.isLoading
                      ? "pointer-events-none cursor-not-allowed"
                      : ""
                  }`}
                    >
                      <div
                        className="h-9 flex justify-center items-center shadow-none rounded-lg btn_header"
                        variant="outlined"
                        onClick={handleMarketplaceMenuButtonClick}
                      >
                        <p
                          className="pr-1.5 font-es"
                          style={{ color: "#6B7280" }}
                        >
                          MP :
                        </p>
                        <span className="text-white rounded-lg btn_mp_badge">
                          {getUpdatedMarketplaceText(props.filter.marketplace)}
                        </span>
                        <div className="flex justify-center items-center text-black hover:text-primary">
                          <ExpandMoreRoundedIcon style={{ fontSize: "26px" }} />
                        </div>
                      </div>
                      <Menu
                        open={Boolean(anchorEl)}
                        keepMounted
                        anchorEl={anchorEl}
                        onClose={(event) =>
                          handleMarketplaceMenuClose(event, "all")
                        }
                      >
                        <div
                          className={`${
                            props.isLoading ? "cursor-not-allowed" : ""
                          }`}
                        >
                          <div
                            className={`${
                              props.isLoading
                                ? "pointer-events-none cursor-not-allowed"
                                : ""
                            }`}
                          >
                            {/* {isSelectionBool ? (
                              <Button
                                onClick={() => handleMarketplaceSelection(true)}
                                className="bg-primary text-white rounded-lg normal-case ml-1"
                                variant="contained"
                                size="medium"
                              >
                                Select All
                              </Button>
                            ) : (
                              <Button
                                onClick={() =>
                                  handleMarketplaceSelection(false)
                                }
                                className="bg-primary text-white rounded-lg normal-case ml-1"
                                variant="contained"
                                size="medium"
                              >
                                Unselect All
                              </Button>
                            )} */}
                            <CustomMenuItem key={1}>
                              <CustomCheckBox
                                indeterminate={indeterminate}
                                onChange={toggleSelectAll}
                                checked={selectAll}
                                className="text-primary"
                                style={{ whiteSpace: "nowrap" }}
                               
                              />
                              Select All
                            </CustomMenuItem>
                            {props.filter.marketplace?.map((row) => (
                              <CustomMenuItem key={row.id}>
                                <CustomCheckBox
                                  defaultChecked={row.checked}
                                  checked={row.checked}
                                  className="text-primary"
                                  onChange={(event) =>
                                    handleMarketplaceCheck(event, row)
                                  }
                                />
                                {row.name}
                              </CustomMenuItem>
                            ))}
                            <div className="flex justify-center">
                              <Button
                                className="bg-primary text-white rounded-lg normal-case"
                                startIcon={<DoneRoundedIcon />}
                                variant="contained"
                                size="medium"
                                onClick={onChannelSubmit}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Menu>
                    </div>
                  </div>
                )}
                {/* Marketplace 🔴 */}
                {/* Today Yesterday Last Week Last Month 🟢 */}
                {/* <div
                className={`nav flex justify-center items-center text-sm font-medium hover:shadow-md h-9
                  ${props.isLoading ? "cursor-not-allowed" : ""}`}
                style={{
                  padding: "2.5px",
                  background: "rgb(232, 232, 240)",
                  borderRadius: "9px",
                }}
              >
                <div
                  className={`${
                    props.isLoading
                      ? "pointer-events-none cursor-not-allowed"
                      : ""
                  }`}
                >
                  <Radio.Group
                    value={props.filter.dateFilter}
                    buttonStyle="solid"
                    onChange={(e) =>
                      handleQuickDateFilterType(e, e.target.value)
                    }
                  >
                    {quickDateFilters.map((row, i) => (
                      <Radio.Button value={row.id} key={i} className="radioCls">
                        {row.name}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              </div> */}
                {/* Today Yesterday Last Week Last Month 🔴 */}
              </>

              {/* <>{props.customFilterUi}</> */}
              {/* Create Campaign 🟢 */}
              {props.campaigns && (
                <Button
                  className="bg-primary text-white normal-case rounded-lg"
                  variant="contained"
                  size="medium"
                  startIcon={<NoteAddRoundedIcon />}
                  onClick={() => history(`/create-campaigns`)}
                  disableElevation
                >
                  Create Campaign
                </Button>
              )}
              {/* Create Campaign 🔴 */}
            </div>
            <div className="px-1 relative">
              {/* <span className="notify"></span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                />
              </svg> */}
            </div>

            <Tooltip
              title={data?.org_name}
              placement="bottomLeft"
              color="#108ee9"
            >
              <Avatar style={{ backgroundColor: "#2b3990" }}>
                {data?.org_name?.charAt(0)?.toUpperCase()}
              </Avatar>
            </Tooltip>
          </div>
          {/* Left Section 🔴 */}
        </div>
      </div>
      {/* Common Section 🔴 */}

      {/* {props.showManualSync && (
        <div className="">
          <ManualSyncButton
            variant="contained"
            disabled={!showManualSync}
            onClick={() => {
              if (!loading) {
                handleManualSync();
                props.handleManualSyncClick();
              }
            }}
            style={{
              background: loading || !showManualSync ? "#FAFBFC" : "#2684FF",
              color: loading || !showManualSync ? "#717480" : "#fff",
            }}
            disableElevation
          >
            Manual Sync
          </ManualSyncButton>
          {props.syncDate && !loading && (
            <div className="text-xs text-SpaceBlack whitespace-nowrap absolute -ml-3">
              Last sync {moment(props.syncDate).fromNow()}
            </div>
          )}

          {loading && (
            <div className="absolute top-10 right-2">
              <LoadingOutlined style={{ fontSize: 20, color: "#2684FF" }} />
            </div>
          )}
        </div>
      )} */}

      {/* <div
        className="flex items-center justify-center"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
      </div> */}
    </div>
  );
}

CustomFilterHeader.defaultProps = {
  handleMarketplaceChange: undefined,
  headerTitle: "",
  showDateRanges: true,
  showManualSync: true,
  handleManualSyncClick: undefined,
  onSearchTextEntered: undefined,
  onProfitToggleChange: undefined,
  showReviewToggle: false,
  onReviewTypeChanged: undefined,
  showExportButton: true,
  showSearchBar: true,
  manualSyncModule: "",
  customHeader: <></>,
  customFilterUi: <></>,
  customDateText: "",
};

CustomFilterHeader.propTypes = {
  handleMarketplaceChange: PropTypes.func,
  headerTitle: PropTypes.string,
  showDateRanges: PropTypes.bool,
  showManualSync: PropTypes.bool,
  handleManualSyncClick: PropTypes.func,
  onSearchTextEntered: PropTypes.func,
  onProfitToggleChange: PropTypes.func,
  showReviewToggle: PropTypes.bool,
  onReviewTypeChanged: PropTypes.func,
  showExportButton: PropTypes.bool,
  showSearchBar: PropTypes.bool,
  manualSyncModule: PropTypes.string,
  customDateText: PropTypes.string,
};

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => {
  return {
    updateMarketplace: (marketplaceInfo) =>
      dispatch({
        type: "filter/updateMarketplace",
        payload: {
          marketplace: marketplaceInfo.marketplace,
        },
      }),
    updateDateFilter: (dateInfo) =>
      dispatch({
        type: "filter/updateDateFilter",
        payload: {
          dateFilter: dateInfo.dateFilter,
          startDate: dateInfo.startDate,
          endDate: dateInfo.endDate,
        },
      }),
    updateReviewFilter: (reviewInfo) =>
      dispatch({
        type: "filter/updateReviewFilter",
        payload: {
          reviewStatus: reviewInfo.reviewStatus,
        },
      }),
    updateSliderFilter: (sliderInfo) =>
      dispatch({
        type: "filter/updateSliderFilter",
        payload: {
          sliderCollapsed: sliderInfo.sliderCollapsed,
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomFilterHeader);
